import React, { useMemo } from 'react';
import { styled, Link as MuiLink } from '@mui/material';
import { omit } from 'lodash-es';
import clsx from 'clsx';
import { getStyle, linkClasses } from './style';
import IconArrow from './Arrow';
const LinkBase = React.forwardRef((props, ref) => {
    const { disabled = false, target, rel, children, endIcon, showArrowIcon = true, classes, onClick, type, className, ...rest } = props;
    const isStandalone = target === '_blank';
    const newRel = !rel && isStandalone ? 'noopener noreferrer' : rel;
    const displayIcon = useMemo(() => {
        if (endIcon)
            return endIcon;
        if (isStandalone && showArrowIcon)
            return React.createElement(IconArrow, { className: linkClasses.icon });
        return null;
    }, [endIcon, isStandalone, showArrowIcon]);
    let restProps = rest;
    if (disabled) {
        restProps = omit(restProps, ['onClick', 'href']);
    }
    function handleKeyPress(e) {
        if (e.currentTarget.tagName === 'A' && !disabled && e.key === 'Enter') {
            onClick?.(e);
        }
        restProps.onKeyPress?.(e);
    }
    return (React.createElement(MuiLink, { ref: ref, rel: newRel, target: target, role: "link", tabIndex: disabled ? -1 : 0, "aria-disabled": disabled, ...omit(restProps, ['style']), onClick: disabled
            ? (e) => {
                e.preventDefault();
            }
            : onClick, onKeyPress: handleKeyPress, classes: {
            ...classes,
            root: linkClasses.root,
            focusVisible: linkClasses.focusVisible,
        }, className: clsx({
            [linkClasses.primary]: type === 'primary',
            [linkClasses.secondary]: type === 'secondary',
        }, className) },
        children,
        displayIcon));
});
const StyledLink = styled(LinkBase)((props) => {
    const { theme, disabled, type, underline } = props;
    return getStyle(theme, { disabled, type, underline });
});
const Link = React.forwardRef((props, ref) => (React.createElement(StyledLink, { ...props, ref: ref })));
export { Link };
